import AppLayout from '../layouts/Layout'
import * as React from 'react';
import {Box, Tabs, Tab, Typography, Container, Grid} from "@mui/material"
import RequestLink from '../components/RequestLink';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}


const MainPage = () => {

  return (
    <AppLayout>
      <Container
        sx={{
          flexGrow: 1,
          bgcolor: 'background.paper',
          display: 'flex',
          height: 224,
          maxWidth: 1000,
          justifyContent: 'center',
          margin: '0 auto'
        }}
      >
          <Grid container spacing={2} sx={{mt: 2}}>
              <Grid item xs={2}>
              </Grid>
              <Grid item xs={8}>
                  <RequestLink reviewElement={0}/>
              </Grid>
              <Grid item xs={2}>
              </Grid>
          </Grid>

      </Container>
    </AppLayout>
  )
}

export default MainPage